import { render, staticRenderFns } from "./OneStep.vue?vue&type=template&id=0955234c"
import script from "./OneStep.vue?vue&type=script&lang=ts"
export * from "./OneStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports